<template>
  <div
    class="ratios-drag-handle"
    :class="{ 'is-active': active }"
    :style="{ top: `${topPx}px` }"
    @pointerdown.prevent="emit('pointerdown', $event)">
    <span class="ratios-drag-handle__line" />
    <div class="ratios-drag-handle__cluster">
      <button
        type="button"
        class="ratios-drag-handle__nudge ratios-drag-handle__nudge--up"
        title="Move split up"
        aria-label="Move split up"
        @click.prevent.stop="emit('nudgeUp')"
        @pointerdown.stop>
        <span class="ratios-drag-handle__triangle" />
      </button>
      <button type="button" class="ratios-drag-handle__grip" aria-label="Resize usages" title="Resize usages" />
      <button
        type="button"
        class="ratios-drag-handle__nudge ratios-drag-handle__nudge--down"
        title="Move split down"
        aria-label="Move split down"
        @click.prevent.stop="emit('nudgeDown')"
        @pointerdown.stop>
        <span class="ratios-drag-handle__triangle" />
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  topPx: number
  active?: boolean
}>()

const emit = defineEmits<{
  pointerdown: [event: PointerEvent]
  nudgeUp: []
  nudgeDown: []
}>()
</script>

<style lang="postcss" scoped>
.ratios-drag-handle {
  @apply absolute left-0 z-30 w-full cursor-row-resize bg-transparent;
  height: 40px;
  transform: translateY(-50%);
  pointer-events: auto;
}

.ratios-drag-handle__line {
  @apply absolute left-0 right-0 block;
  top: 50%;
  height: 1px;
  background-color: rgba(209, 213, 219, 1);
  transition: background-color 0.15s ease;
  pointer-events: none;
}

.ratios-drag-handle__cluster {
  @apply absolute left-1/2 top-1/2;
  width: 36px;
  height: 36px;
  transform: translate(-50%, -50%);
  pointer-events: auto;
}

.ratios-drag-handle__nudge {
  @apply absolute left-1/2 z-10 flex items-center justify-center border-0 bg-transparent p-0 opacity-0;
  width: 14px;
  height: 11px;
  transform: translateX(-50%);
  transition: opacity 120ms ease;
  pointer-events: none;
  cursor: pointer;
}

.ratios-drag-handle__nudge--up {
  top: 0;
}

.ratios-drag-handle__nudge--down {
  bottom: 0;
}

.ratios-drag-handle__triangle {
  display: block;
  width: 7px;
  height: 6px;
  background: rgba(107, 114, 128, 0.85);
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
}

.ratios-drag-handle__nudge--down .ratios-drag-handle__triangle {
  transform: rotate(180deg);
}

.ratios-drag-handle__grip {
  @apply absolute left-1/2 top-1/2 block rounded-full border p-0;
  width: 34px;
  height: 8px;
  transform: translate(-50%, -50%);
  border-width: 1px;
  border-color: rgba(209, 213, 219, 1);
  background: #ffffff;
  transition: border-color 0.15s ease;
  cursor: row-resize;
}

.ratios-drag-handle:hover .ratios-drag-handle__nudge {
  opacity: 1;
  pointer-events: auto;
}

.ratios-drag-handle:hover .ratios-drag-handle__grip,
.ratios-drag-handle.is-active .ratios-drag-handle__grip {
  @apply border-primary-default;
}

.ratios-drag-handle:hover .ratios-drag-handle__line,
.ratios-drag-handle.is-active .ratios-drag-handle__line {
  background-color: var(--color-primary-default);
}

.ratios-drag-handle__nudge:hover {
  opacity: 1;
}

.ratios-drag-handle__nudge:hover .ratios-drag-handle__triangle {
  background: rgba(55, 65, 81, 0.95);
}
</style>
